<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({
  observation: { type: String, default: '' },
});

const { t } = useI18n();
</script>

<template>
  <LaisCard
    class="mt-5"
    :title="t('REAL_ESTATE_COMMISSION_PLAN.FIELDS.MANAGER_OBSERVATION')"
    prefix-icon="i-lucide-message-square-text"
  >
    <p class="whitespace-pre-wrap text-sm text-lais-text-body">
      {{ observation || t('REAL_ESTATE_COMMISSION_PLAN.COMMON.EMPTY_NOTE') }}
    </p>
  </LaisCard>
</template>
